<template>
  <div class="card-popup" v-if="!cardLoading">
    <Floating
      :visible.sync="showCard"
      :width="'470px'"
      :close-on-click-modal="false"
      v-if="!isH5 && showCard"
      custom-class="card-popup-floating el-floating_d-reset"
      :title="$t('支付方式选择')"
      @close="closeDrawer"
      :appendToBody="false"
    >
      <CardContent @update="getInit" />
      <div class="info-btn">
        <el-button @click="confirmClick">{{ $t('确认') }}</el-button>
      </div>
    </Floating>
    <DrawerPopup
      v-if="isH5 && showCard"
      size="90%"
      :show="showCard"
      :appendToBody="false"
      :title="$t('支付方式选择')"
      :bottomName="$t('确认')"
      @close="closeDrawer"
      @bottom-click="confirmClick"
    >
      <CardContent @update="getInit" />
    </DrawerPopup>
  </div>
</template>

<script>
import CardContent from './cardContent.vue';
import DrawerPopup from '@/components/DrawerPopup';
import { Floating } from '@didi/r-fusion-pc';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  name: 'CardPopup',
  components: {
    CardContent,
    DrawerPopup,
    Floating,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    paymentParams: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showCard: false,
      cardObj: {},
      cardLoading: false,
    };
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
      extraInfoList: ({ pay }) => pay.extraInfoList,
      selectedMent: ({ pay }) => pay.selectedMent,
      selectedCard: ({ pay }) => pay.selectedCard,
      cardLoading: ({ pay }) => pay.cardLoading,
    }),
  },
  watch: {
    value(val) {
      this.showCard = val;

    },
    showCard(val) {
      if(!val) this.delPayData()
      this.$emit('input', val);
    },
  },
  async mounted() {
    this.getInit();
  },
  methods: {
    ...mapActions('pay', ['getPayInfo','delPayData']),
    ...mapMutations('pay', [
      'setSelectedCard',
      'setSelectedMent',
      'setCardLoading',
    ]),
    async getInit() {
      this.setCardLoading(true);
      await this.getPayInfo(this.paymentParams);
      this.setCardLoading(false);
    },
    closeDrawer() {
      this.setSelectedMent(this.selectedCard);
      this.showCard = false;
      this?.closeDrawer2();
    },
    confirmClick() {
      this.setSelectedCard(this.selectedMent);
      this.showCard = false;
      this?.confirmClick2();
      // this.$emit('update', this.selectedMent);
    },
  },
};
</script>

<style lang="scss" scoped>
.info-btn {
  padding: 20px 24px 20px 0;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
  .el-button {
    min-width: 140px;
  }
}
</style>
<style lang="scss">
.card-popup-floating {
  background: #f5f5f7;
}
.card-popup .el-drawer {
  background: #f5f5f7;
}
</style>
